import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import OneVerseLogo from '@/components/OneVerseLogo';

const DesignSystemLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header with One Verse Logo */}
      <header className="border-b border-gray-200 px-8 py-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <div className="flex items-center">
                <Link to="/">
                  <OneVerseLogo className="h-8" />
                </Link>
              </div>
            </div>
            <div className="lg:col-span-3"></div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};

export default DesignSystemLayout;
